import React, { useEffect } from "react";
import './styles.css'
import { useNavigate } from "react-router-dom";
import { useUser } from "../../../redux/useStore";
// import Logo from "../../../assets/logo.webp";
import { useAxios } from "../../../hooks/useAxios";
import { ApiCollection, MERCHANT_KEY, MERCHANT_SALT, udf1 } from "../../../config/envConfig";
import SpinnerLoader from "../../../components/loader";
import { AssessmentListItem } from "../../../utils/interface/assessment";
import AssessmentCard from "../../../components/assessmentCard";
import CryptoJS from 'crypto-js';
import "react-multi-carousel/lib/styles.css";
// import { LockUnlocked } from "solar-icon-set/security";
import { PAYU_BASE_URL, envConfig } from "../../../config/envConfig";
import Modal from "../../../components/modal";
import { logEvent, logException } from '../../../utils/analytics/analytics';
import { useOneSignalUser } from '../../../hooks/useOneSignalUser';
import { Colors } from "../../../utils/constants/colors";
import { offers } from "../../../utils/constants/offers";
import { Tag } from "solar-icon-set/money";
import { CheckCircle } from "solar-icon-set/essentionalui";
import { toast } from 'react-toastify';



interface PaymentData {
    key: string;
    txnid: string;
    amount: number;
    productinfo: string;
    firstname: string;
    email: string;
    phone: string;
    surl: string;
    furl: string;
    service_provider?: string;
    udf1?: string;
    udf2?: string;
    udf3?: number;
    hash?: string;
    pg?: string;
    bankcode?: string;
}



const AssessmentListScreen = () => {
    const { tagUser } = useOneSignalUser();

    // path detection
    useEffect(() => {
        const path = window.location.pathname;
        if (path === '/') {
            navigate('/assessments')
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);


    const navigate = useNavigate()

    const user = useUser()
    const axios = useAxios()


    const [assessments, setAssessments] = React.useState<AssessmentListItem[]>([]);
    const [isLoading, setIsLoading] = React.useState<Boolean>(true);

    const [showCheckout, setShowCheckout] = React.useState<Boolean>(false)
    // const [selectedPlanId, setSelectedPlanId] = React.useState<any>(null)
    const [selectedAssessments, setSelectedAssessments] = React.useState<AssessmentListItem[]>([])

    const avialableAssessments = assessments.filter(ass => (ass.price > 0 && ass.is_unlocked === false))


    const [couponText, setCouponText] = React.useState<string>('');
    const [couponDiscount, setCouponDiscount] = React.useState<number>(0)
    const [isCouponLoading, setIsCouponLoading] = React.useState<boolean>(false);

    const [isValidating, setIsValidating] = React.useState<boolean>(false);


    useEffect(() => {
        getAssessments()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (getCheckoutPricing().payable <= 0) {
            setCouponDiscount(0)
            setCouponText('')
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedAssessments])



    const getAssessments = async () => {
        setIsLoading(true)
        await axios.get(ApiCollection.exam.getAssessmentList)
            .then((res) => {
                setAssessments(res.data.assessments)

            })
            .catch((err) => {
                console.log(err)
            })
            .finally(() => {
                setIsLoading(false)
            })
    }



    const onAssessmentClick = (assessment: AssessmentListItem) => {
        if (user?.role === 'student') {
            if (assessment.is_unlocked) {
                logEvent('Assessment', `Assessment View Click ${assessment.title}`, `${assessment.title}`, {
                    assessment_id: assessment.id,
                    assessment_parent_id: assessment.parent_id,
                    assessment_title: assessment.title,
                    assessment_subject: assessment.subject,
                    assessment_price: assessment.price,
                    is_unlocked: assessment.is_unlocked,
                    user_id: user?.id,
                    user_role: user?.role,
                    user_class: user?.educationalInfo?.class,
                    timestamp: new Date().toISOString()
                });
                navigate(`/assessments/view?assessmentId=${assessment.id}`)
                return;
            } else {
                logEvent('Assessment', `Unlock Attempt Click ${assessment.title}`, `${assessment.title}`, {
                    assessment_id: assessment.id,
                    assessment_title: assessment.title,
                    assessment_subject: assessment.subject,
                    assessment_parent_id: assessment.parent_id,
                    assessment_price: assessment.price,
                    is_unlocked: assessment.is_unlocked,
                    user_id: user?.id,
                    user_role: user?.role,
                    user_class: user?.educationalInfo?.class,
                    timestamp: new Date().toISOString()
                });
                setSelectedAssessments([assessment])
                setShowCheckout(true)
            }
        } else {
            navigate(`/assessments/view?assessmentId=${assessment.id}`)
        }
    }




    const handleCheckout = async () => {
        try {
            setIsValidating(true);
            const selectedIds = selectedAssessments.map(assessment => assessment.parent_id);
            
          
      try {
        const validationResponse = await axios.post(ApiCollection.subject.validateLockedSubject, {
          parent_id: selectedIds
        });

        // Only proceeds to PayU if validation is successful
        if (!validationResponse.data.status) {
          toast.error('Some subjects are not available for purchase.', {
            position: "top-right"
          });
          return;
        }
      } catch (error:any) {
        // console.log('Error validating subjects:', error);
        toast.error(error.response.data.detail, {
          position: "top-right"
        });
        return;
      } finally {
        setIsValidating(false);
      }
    
            const checkoutProperties = {
                subscription_plan: `Multiple Assessments (${selectedAssessments.length})`,
                purchase_amount: getCheckoutPricing().payable,
                selected_assessment_ids: selectedAssessments.map(a => a.id),
                selected_assessment_parent_ids: selectedAssessments.map(a => a.parent_id),
                selected_assessment_titles: selectedAssessments.map(a => a.title),
                selected_assessment_count: selectedAssessments.length
            };

            logEvent('Purchase', 'Checkout Attempt', '', checkoutProperties);

            if (!MERCHANT_KEY) {
                throw new Error('MERCHANT_KEY is not configured');
            }

            let basePaymentData: PaymentData = {
                key: MERCHANT_KEY,
                txnid: `txn_${Date.now()}`,
                amount: getCheckoutPricing().payable,
                productinfo: `Multiple Assessments (${selectedAssessments.length})`,
                firstname: user?.firstName || "",
                email: user?.email || "",
                phone: user?.mobileNo || "",
                surl: `${ApiCollection.payment.logSuccess}`,
                furl: `${ApiCollection.payment.logFailure}`,
                udf2: selectedIds.join(','),
            };

            if (envConfig.isProd) {
                basePaymentData.service_provider = "payu_paisa"
                basePaymentData.udf1 = udf1
            } else {
                basePaymentData.service_provider = "payu_paisa"
                basePaymentData.udf1 = udf1
                // basePaymentData.pg = "TESTPG"
                // basePaymentData.bankcode = "TESTPGNB"
                // basePaymentData.udf1 = udf1
            }

            const data = basePaymentData
            const hashString = `${MERCHANT_KEY || ''}|${data.txnid}|${data.amount}|${data.productinfo}|${data.firstname}|${data.email}|${data.udf1}|${data.udf2}|||||||||${MERCHANT_SALT}`;
            data.hash = CryptoJS.SHA512(hashString).toString();

            const form = document.createElement('form');
            form.method = 'post';
            if (!PAYU_BASE_URL) {
                throw new Error('PAYU_BASE_URL is not configured');
            }
            form.action = PAYU_BASE_URL;

            for (const [key, value] of Object.entries(data)) {
                if (value !== undefined) {
                    const input = document.createElement('input');
                    input.type = 'hidden';
                    input.name = key;
                    input.value = value.toString();
                    form.appendChild(input);
                }
            }

            document.body.appendChild(form);
            form.submit();
            document.body.removeChild(form);
            const transactionInfo = `Transaction: ${data.txnid}, NumberOfSubjects: ${selectedAssessments.length}, Amount: ${data.amount}`;
            logEvent('Purchase', 'Checkout Form Submitted', transactionInfo);

            if (!user?.id) {
                throw new Error('User data is missing');
            }

            await tagUser({
                id: user.id,
                email: user.email || '',
                user_role: user.role || '',
                mobile_number: user.mobileNo,
                first_name: user.firstName || '',
                last_name: user.lastName || '',
                educational_info: {
                    class: user.educationalInfo?.class || ''
                }
            });
        } catch (error:any) {
            logException('Checkout Error', true, error as Error);
            console.error('Error during checkout:', error);
            toast.error(error.data.detail, {
                position: "top-right"   
            }); 
        }
        finally {
            setSelectedAssessments([])
            // setSelectedPlanId(null)
            setShowCheckout(false)
        }
    };


    const onSubjectClick = (assessment: AssessmentListItem) => {
        const thisAssess = selectedAssessments.find(ass => ass.id === assessment.id)
        if (thisAssess) {
            logEvent('Assessment', 'Remove from Cart', '', {
                assessment_id: assessment.id,
                assessment_parent_id: assessment.parent_id,
                assessment_title: assessment.title,
                action_type: 'remove'
            });
            setSelectedAssessments(selectedAssessments.filter(ass => ass.id !== assessment.id))
        } else {
            logEvent('Assessment', 'Added to Cart', '', {
                assessment_id: assessment.id,
                assessment_parent_id: assessment.parent_id,
                assessment_title: assessment.title,
                // selected_plan_id: selectedPlanId,
                action_type: 'Add'
            });
            setSelectedAssessments([...selectedAssessments, assessment])
        }
    }





    const getCheckoutPricing = () => {


        let cartValue = selectedAssessments.reduce((a, b) => a + b.price, 0)

        let offer = offers.find(off => off.minimumCartQuantity === selectedAssessments.length) || null

        let discount = offer ? offer.discount : 0

        let data = {
            discountAmount: discount,
            withDiscount: (cartValue - discount),
            payable: (cartValue - discount),
            cartValue: cartValue,
            offer,
            couponDiscount,
        }

        if (couponDiscount > 0) {
            data.payable = Number((data.withDiscount - (data.withDiscount * (couponDiscount / 100))).toFixed(2));
            data.couponDiscount = Number((data.withDiscount * (couponDiscount / 100)).toFixed(2));
        }

        if (data.payable <= 0) {
            data.payable = 0
            data.withDiscount = 0
            data.discountAmount = 0
            data.cartValue = 0
            data.offer = null
            data.couponDiscount = 0
        }



        return data

    }

    const onCouponApply = async () => {
        setIsCouponLoading(true);
        try {
            const response = await axios.get(`${ApiCollection.user.applyCoupon}${couponText}/`);

            if (response.data.status) {
                const discountPercentage = parseFloat(response.data.discount);
                setCouponDiscount(discountPercentage);
                toast.success(response.data.message, {
                    position: "top-right"
                });
            } else {
                toast.error(response.data.message, {
                    position: "top-right"
                });
                setCouponDiscount(0);
            }
        } catch (error) {
            console.error('Error applying coupon:', error);
            toast.error('Error applying coupon', {
                position: "top-right"
            });
            setCouponDiscount(0);
        } finally {
            setIsCouponLoading(false);
        }
    };

    // const onUnlockAll = () => {
    //     let temp: AssessmentListItem[] = []
    //     avialableAssessments.forEach(ass => {
    //         temp.push(ass)
    //     })
    //     setSelectedAssessments(temp)
    //     setShowCheckout(true)
    // }

    if (isLoading) {
        return (
            <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column', height: '100vh', width: '100%' }}>
                <SpinnerLoader />
                <h2 style={{ marginTop: 10, fontSize: 20 }}>
                    Loading Assessments...
                </h2>
            </div>
        )

    }


    return (
        <div className="assessment_list">

            {/* <div className="mobile_header">
                <div className="mobile_header_left">
                    <img
                        src={Logo}
                        alt="Chanakya Logo"
                        className="mobile_header__logo"
                    />
                    <div className="mobile_header__title">
                        <span>Welcome to</span>
                        <h2 className="heading">Chanakya Assessments</h2>
                    </div>
                </div>


                {
                    avialableAssessments.length > 0 &&
                    <div style={{ marginRight: 20 }}>
                        <button className="primary_btn unlock" onClick={onUnlockAll}>
                            <LockUnlocked size={22} />
                            <span className="label" style={{ marginLeft: 10 }}>Unlock All</span>
                        </button>
                    </div>
                }


            </div> */}

            <div className="page-wrapper">
                <div className="assessment_list__header">
                    <div style={{ display: 'flex', alignItems: 'flex-start', flexDirection: 'column', justifyContent: 'flex-start' }}>
                        <h2 style={{ marginTop: 5, fontSize: 20 }}>Available Study Material</h2>
                    </div>

                </div>


                <div className="assessment_list_content">

                    {
                        assessments.length > 0 ?
                            assessments.map((assessment) => (
                                <AssessmentCard
                                    key={assessment.id}
                                    assessment={assessment}
                                    onAssessmentClick={onAssessmentClick}
                                />
                            ))
                            :
                            <div >
                                <span>No resources available right now ! Please comeback later.</span>
                            </div>
                    }

                </div>
            </div>

            {
                showCheckout &&
                <Modal
                    onClose={() => {
                        setShowCheckout(false)
                        // setSelectedPlanId(null)
                        setSelectedAssessments([])
                    }}
                >
                    {
                        // selectedPlanId == null ?
                        //     <div className="plans_holder">
                        //         <div className="plans_holder_head">
                        //             <h2 className="modal_heading">🚀 Boost Your Exam Preparation !</h2>
                        //             <span className="modal_description">Unlock more with our super saver bundles or purchase any subject you want !</span>
                        //         </div>
                        //         <PricingPlans
                        //             onPlanSelect={(id: string) => setSelectedPlanId(id)}
                        //         />
                        //     </div>
                        //     :
                        <div className="plans_holder">
                            <div className="plans_holder_head">
                                <h2 className="modal_heading">🚀 Boost Your Exam Preparation !</h2>
                                <span className="modal_description">Unlock any subject(s) of your choice and boost your preparations for upcoming exams.</span>
                            </div>
                            <div className="checkout_holder">
                                <div className="subject_holder">
                                    <div className="sub_selector">
                                        <h3>Available Resource(s)</h3>
                                        <div className="sub_holder">
                                            {avialableAssessments.length > 0 &&
                                                avialableAssessments.map((assessment, index) => (
                                                    <div key={assessment.id} className={`sub_chip ${selectedAssessments.find(ass => ass.id === assessment.id) ? 'selected' : ''}`}
                                                        onClick={() => onSubjectClick(assessment)}>
                                                        {assessment.subject}
                                                    </div>
                                                ))
                                            }
                                        </div>

                                    </div>

                                    <div className="offer_holder">
                                        {
                                            selectedAssessments.length > 0 &&
                                            <div className="offer_holder coupon_section">
                                                <h3 style={{ fontWeight: 'bold', textDecoration: 'underline', fontSize: 16 }}>Enter Coupon Code</h3>
                                                <div className="coupon_input">
                                                    <input type="text" placeholder="Enter Coupon Code"
                                                        value={couponText}
                                                        onChange={(e) => setCouponText(e.target.value)}
                                                    />
                                                    <button
                                                        onClick={onCouponApply}
                                                        disabled={couponText.length === 0 || isCouponLoading}
                                                        className="primary_btn coupon_apply"
                                                    >
                                                        {isCouponLoading ? (
                                                            <div className="button-loader"></div>
                                                        ) : (
                                                            'Apply'
                                                        )}
                                                    </button>
                                                </div>
                                            </div>
                                        }

                                        <h3 style={{ fontWeight: 'bold', textDecoration: 'underline', fontSize: 16 }}>Offers</h3>
                                        {
                                            offers.map((offer) => (
                                                <div className={`offer_card ${getCheckoutPricing().offer?.id === offer.id ? 'active' : ''}`}>
                                                    {
                                                        getCheckoutPricing().offer?.id === offer.id ?
                                                            <CheckCircle size={18} color={Colors.success} iconStyle='Bold' />
                                                            :
                                                            <Tag size={18} color={Colors.primary} iconStyle='Bold' />
                                                    }


                                                    <span>
                                                        {offer.title}
                                                    </span>
                                                </div>
                                            ))
                                        }

                                    </div>

                                </div>
                                <div className="checkout_summary">
                                    <h3>Order Summary</h3>
                                    <div className="order_holder">
                                        <div className="order_item_list">
                                            {selectedAssessments.length > 0 ?
                                                selectedAssessments.map((assessment, index) => (
                                                    <div className="order_item">
                                                        <span className="item_name">1x {assessment.title}</span>
                                                        <span className="item_price">Rs. {assessment.price || 0}</span>
                                                    </div>
                                                ))
                                                :
                                                <div className="order_item">
                                                    <span>Select any paper</span>
                                                </div>
                                            }
                                        </div>

                                        <div className="order_checkout_section">
                                            {getCheckoutPricing().discountAmount > 0 &&
                                                <div className="order_item discount">
                                                    <span>Offer Discount</span>
                                                    <span>- Rs. {getCheckoutPricing().discountAmount}</span>
                                                </div>
                                            }

                                            {getCheckoutPricing().couponDiscount > 0 && couponText.length > 0 &&
                                                <div className="order_item discount">
                                                    <span>Coupon Discount</span>
                                                    <span>- Rs. {getCheckoutPricing().couponDiscount}</span>
                                                </div>
                                            }

                                            <div className="order_item">
                                                <span>Total</span>
                                                <span>Rs. {getCheckoutPricing().payable}</span>
                                            </div>
                                            <button
                                                style={{ width: '100%' }}
                                                className="primary_btn"
                                                onClick={handleCheckout}
                                                disabled={selectedAssessments.length === 0 || getCheckoutPricing().payable <= 0 || isValidating}
                                            >
                                                {isValidating ? (
                                                    <div className="assessment-button-loader"></div>
                                                ) : (
                                                    'Proceed To Checkout'
                                                )}
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                </Modal>
            }


        </div >
    )
}

export default AssessmentListScreen;